import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import ManagePage from '../../views/ManagePage/';

class TaskDetails extends Component {
	
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			id : '',
			posts : []
		}
		
		this.handleClick = this.handleClick.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	/** redirect to Subject **/
	onBack(e){
		
		this.setState({_redirect :true});
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").show();
			PostData('task/deletetask',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Task Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Class',
						alertClass:'alert alert-danger'
					});
				}
			});
		}	
	}
	
	
	componentWillMount(){
		
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('task/gettask').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/task/addtask' />);
	}
	
    return (
		<div>
		  <ManagePage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>Task Details</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.onBack}>Add Task</Button>
							</span>
						</CardHeader>
						<CardBody>
							<Table responsive bordered>
								<thead>
									<tr>
										<th>S.No</th>
										<th>Task</th>
										<th>Priority</th>
										<th>Task Date</th>
										<th>Status</th>
										<th width="100">Manage</th>
									</tr>
								</thead>
								<tbody>
									{this.state.posts.map(item =>
									 
										<tr key = {item}>
											<td>{item.id}</td>
											<td>{item.task}</td>
											<td>{item.priority}</td>
											<td>{item.taskdate}</td>
											<td>{item.taskstatus}</td>
											<td>
												<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
											</td>
										</tr>

									 )}
								</tbody>
							</Table>
						</CardBody>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	);
  }
}

export default TaskDetails;



// WEBPACK FOOTER //
// ./src/task/AssignTask/TaskDetails.js